import { useState } from "react";
import styles from "./DropdownDepartmentsInput.module.css";

const DropdownDepartmentsInput = ({
  label,
  data,
  setSpecificState,
  isDepartment,
  initialValue,
  isError,
  isInFirstInput = false,
}) => {
  const [selectionValue, setSelectionValue] = useState(initialValue);
  const findDepartmentId = (selectedValue) => {
    const option = data?.find((option) => option.fullName === selectedValue);
    return option?.id;
  };

  const handleSelectionChange = (event) => {
    const selectedValue = event.target.value;
    const departmentId = findDepartmentId(selectedValue);

    setSpecificState(departmentId);
    setSelectionValue(selectedValue);
  };

  return (
    <div className={styles.dropdownMenuContainer}>
      <label>{label}</label>
      {isError && <p className={styles.errorText}>Ovo polje je obavezno</p>}
      <select
        value={selectionValue}
        onChange={handleSelectionChange}
        className={`${isError ? styles.error : ""} ${
          isInFirstInput ? styles.firstInput : ""
        }`}
      >
        <option value="">Odaberi opciju</option>
        {data?.map((department, index) => (
          <option
            key={index}
            value={department.fullName}
            selected={initialValue === department.fullName}
          >
            {isDepartment
              ? department.fullName.split(" - ")[0]
              : department.fullName}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DropdownDepartmentsInput;
